export enum AccionDialogEnum {
  Crear = 'crear',
  Guardar = 'guardar',
  Editar  = 'editar',
  EditarParcial  = 'editarParcial', //patch
  EditarCompleto  = 'editarCompleto', //completo
  Eliminar = 'eliminar',
  BorradoMultiple = 'borradoMultiple',
  EliminarArchivo = 'eliminarArchivo',
  Importar = 'importar',
  Actualizar = 'actualizar',
  Enviar = 'enviar',
}
